import BaseRepository from '@/baseRepository/BaseRepository';
const resource = `/api/v1/serviceprices`;

export default {
  getServicePrices(baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${resource}`, {
      baseURL,
      headers,
      params,
    });
  },
};
